import { QuizzListPage } from './../quizz-list/quizz-list';
import { NavController, NavParams, App, ModalController, ViewController, Platform } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { SettingsPage } from '../settings/settings';
import { WelcomePage } from '../../welcome/welcome';
import { Component, OnInit, Input } from '@angular/core';

import { UserProvider, User } from '../../../providers/user/user';
import { Response } from '../../../providers/response';
import { CompanyProvider, Company } from '../../../providers/company/company';
import { Club } from '../../../providers/club/club';
import { Post, PostProvider } from '../../../providers/post/post';
import { FormGroup, Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { AvatarProvider } from '../../../providers/avatar/avatar';
import { AuthProvider } from '../../../providers/auth/auth';
import { FeedClub } from '../feed-club/feed-club.component';
import { NetworkPage } from '../network/network';
import { FeedFocusComponent } from './feed-focus/feed-focus.component';
import { TBRProvider } from '../../../providers/tbr/tbr';
import {TranslateService} from "@ngx-translate/core";
import {TabsPage} from "../tabs/tabs";
import {MessagePage} from "../message/message";



@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
})
export class ProfilePage implements OnInit {

  profileNavPosition = 1;

  user: User;
  userCompany: Company;
  clubs: Club[] = [];
  posts: Post[] = [];
  avatarString:string = '';
  latestPost:any;
  userMemberOf:any = [];
  userId:string;
  currUserId:string;
  TBRPersonality:any = null;
  recieivedLikes:number = 0;
  LOCAL:any = 'fr';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private userProvider: UserProvider,
    private companyProvider: CompanyProvider,
    public storageProvider: Storage,
    public app: App,
    public authProvider: AuthProvider,
    private modalCtrl: ModalController,
    private avatarProvider: AvatarProvider,
    public postProvider: PostProvider,
    public tbrProvider: TBRProvider,
    private platform: Platform,
    private viewCtrl: ViewController

  ) {
    this.userId = this.navParams.get('userId')
    this.currUserId = this.authProvider.user.user_id;
    platform.ready().then(() => {
      this.storageProvider.get('LOCAL').then(local => {
        if(local){
          this.LOCAL = local;
        }
      })
    })
  }

  ngOnInit() {
    if (!this.userId){
      this.userId = this.currUserId;
    }

    this.getData();
    this.getProfile();

  }

  getProfile() {
    this.tbrProvider.getPersonality(this.userId).subscribe((res) => {
      if(res.success){
        this.TBRPersonality = res.data;
      }
    })
  }

  getData(): void {
    this.userProvider.get(this.userId).subscribe(
      (res: Response<User>) => {
        this.user = res.data;
        if(res.data.avatar_id) {
          this.avatarProvider.get(res.data.avatar_id).subscribe(
            (res) => {
              try {
                const avatar = res.data.avatar_content
                this.avatarProvider.avatarContent = avatar;
                this.avatarString = avatar;
              } catch (err) {
                console.log(err);
              }
            }
          );
        }
      },
      err => console.log(err)
    );

    this.userProvider.getClubs().subscribe(
      (res: Response<Club[]>) => {
        this.clubs = res.data;
        let myClubs = [];
        // Check if user is member of the club, otherwise remove that club from the list (TODO : This could be handled by backend)
        this.userMemberOf = [];
        this.clubs.forEach((club, index) => {
          club.Members.forEach(member => {
            if(member.user_id == this.userId){
              this.userMemberOf.push(club.id)
              myClubs.push(club)
            }
          });
        });
        this.clubs = myClubs
      },
      err => console.log(err)
    );


    this.postProvider.getLatestOfUser(this.userId).subscribe((res) => {
      if(res.success){
        this.latestPost = res.data
        this.latestPost.forEach(post => {
          this.recieivedLikes += post.Likes.length
        });
      }else{
        console.log(res)
      }
    })
  }

  seePost(postId) {
    let modal = this.modalCtrl.create(FeedFocusComponent, {postId: postId, isClubFeed: false});
    modal.present().then(() => {});
  }



  goToClubs() {
    this.navCtrl.push(NetworkPage, {})
    .then(() => {
    })
  }

  goToSettings() {
    this.navCtrl.push(SettingsPage)
      .then(() => {
        console.log('Welcome to Settings');
      })
  }

  goToQuizz() {
    let modal = this.modalCtrl.create(QuizzListPage)
    modal.present().then(() => {});
    modal.onDidDismiss(() => this.getData())
  }

  toggleEdit(): void {
    if(this.userId == this.currUserId)
      {
        let modal = this.modalCtrl.create(EditProfileComponent, {user: this.user}, {cssClass: 'modal-gradient'});
        modal.present().then(() => {});
        modal.onDidDismiss(() => this.getData())
      }
  }

  goBack() {
    this.viewCtrl.dismiss();
  }

  goToMessage(contact) {
    this.modalCtrl.create(MessagePage, {recipient: [this.user.id, this.user.first_name, this.user.last_name, this.user.position]}).present().then(() => {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/profile/profile.ts